document.addEventListener('DOMContentLoaded', () => {
    const bannerEl = document.querySelector('[data-cmp-banner]')
    if (!(bannerEl instanceof HTMLElement)) {
        return
    }

    const endpoint = bannerEl.dataset.cmpEndpoint || ''
    if (!endpoint) {
        return
    }

    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
    const modalEl = document.getElementById('cmp-settings-modal')
    const modal = modalEl && window.bootstrap ? new window.bootstrap.Modal(modalEl) : null
    const fallbackBackdropId = 'cmp-settings-backdrop'

    const analyticsEl = document.getElementById('cmp-cat-analytics')
    const marketingEl = document.getElementById('cmp-cat-marketing')
    const preferencesEl = document.getElementById('cmp-cat-preferences')

    const openSettingsModal = () => {
        if (!modalEl) {
            return
        }

        if (modal) {
            modal.show()
            return
        }

        modalEl.classList.add('show')
        modalEl.style.display = 'block'
        modalEl.removeAttribute('aria-hidden')
        modalEl.setAttribute('aria-modal', 'true')
        document.body.classList.add('modal-open')

        if (!document.getElementById(fallbackBackdropId)) {
            const backdrop = document.createElement('div')
            backdrop.id = fallbackBackdropId
            backdrop.className = 'modal-backdrop fade show'
            backdrop.addEventListener('click', closeSettingsModal)
            document.body.appendChild(backdrop)
        }
    }

    const closeSettingsModal = () => {
        if (!modalEl) {
            return
        }

        if (modal) {
            modal.hide()
            return
        }

        modalEl.classList.remove('show')
        modalEl.style.display = 'none'
        modalEl.setAttribute('aria-hidden', 'true')
        modalEl.removeAttribute('aria-modal')
        document.body.classList.remove('modal-open')

        const backdrop = document.getElementById(fallbackBackdropId)
        if (backdrop) {
            backdrop.remove()
        }
    }

    const postDecision = async (action, categories = null) => {
        try {
            const payload = {
                action,
                categories: categories || undefined,
            }

            const response = await fetch(endpoint, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': token,
                    Accept: 'application/json',
                },
                body: JSON.stringify(payload),
            })

            if (!response.ok) {
                throw new Error('Consent request failed')
            }

            window.location.reload()
        } catch (error) {
            console.error('[CMP] decision submit failed', error)
        }
    }

    document.querySelectorAll('[data-cmp-open], [data-cmp-open-settings]').forEach((button) => {
        button.addEventListener('click', (event) => {
            event.preventDefault()
            openSettingsModal()
        })
    })

    if (modalEl) {
        modalEl.querySelectorAll('[data-bs-dismiss="modal"]').forEach((button) => {
            button.addEventListener('click', closeSettingsModal)
        })
    }

    document.querySelectorAll('[data-cmp-accept]').forEach((button) => {
        button.addEventListener('click', () => {
            postDecision('accept_all')
        })
    })

    document.querySelectorAll('[data-cmp-essential]').forEach((button) => {
        button.addEventListener('click', () => {
            postDecision('reject_all')
        })
    })

    document.querySelectorAll('[data-cmp-save]').forEach((button) => {
        button.addEventListener('click', () => {
            postDecision('save_preferences', {
                analytics: !!analyticsEl?.checked,
                marketing: !!marketingEl?.checked,
                preferences: !!preferencesEl?.checked,
            })
        })
    })

    document.querySelectorAll('[data-cmp-back]').forEach((button) => {
        button.addEventListener('click', () => {
            closeSettingsModal()
        })
    })

    if (bannerEl.classList.contains('d-none')) {
        bannerEl.style.display = 'none'
    }
})
